<template>
    <div v-if="Array.isArray(value)">
        <div v-if="value.length === 0">{{ placeholder }}</div>
        <div v-else-if="value.length > maxLength">
            <span>{{ value.slice(0, maxLength).join(', ') }}...</span>
            <el-popover trigger="hover" :width="popoverWidth">
                <span>{{ value.join(', ') }}</span>
                <template slot="reference">
                    <el-button type="text">显示全部({{value.length}})</el-button>
                </template>
            </el-popover>
        </div>
        <div v-else>
            <span>{{ value.join(', ') }}</span>
        </div>
    </div>
    <div v-else>{{ ['', undefined, null].includes(value) ? placeholder : value }}</div>
</template>

<script>

export default {
    name: 'array',
    props: {
        value: {},
        maxLength: {
            type: Number,
            default: Infinity
        },
        placeholder: {
            type: [String],
            default: '--'
        },
        popoverWidth: {
            type: [Number, String],
        }
    },
    data() {
        return {};
    }
};
</script>
